import { axiosInstance } from "@/config/axiosInstance";

//  ****** GET CURRENT SUPER ADMIN ******
export const getCurrentSuperAdmin = (superAdminKey: string) =>
  axiosInstance
    .get<{
      success: boolean;
      foundSuperAdmin?: {
        _id: string;
        email: string;
        name: string;
        phone: string;
      };
      error?: string;
    }>("/super/current", {
      headers: {
        authorization: `Bearer ${superAdminKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

//  ****** GET ALL ADMINS ******
export const getAllAdmins = (superAdminKey: string) =>
  axiosInstance
    .post<{
      success: boolean;
      admins: {
        name: string;
        _id: string;
        email: string;
        phone: string;
        blocked: boolean;
      }[];
    }>(
      "/super/admins",
      {},
      {
        headers: {
          authorization: `Bearer ${superAdminKey}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => response.data);

// ? Fetch Admin Action

export const fetchSingleAdmin = (superAdminKey: string) => (adminId: string) =>
  axiosInstance
    .get<{
      success: boolean;
      admin: {
        _id: string;
        email: string;
        name: string;
        blocked: boolean;
        phone: string;
      };
    }>(`/admin/super/fetch/${adminId}`, {
      headers: {
        authorization: `Bearer ${superAdminKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

//  ****** GET ALL EMPLOYEES ******
export const getAllEmployeesForSA = (superAdminKey: string) =>
  axiosInstance
    .post<{
      success: boolean;
      employees: {
        name: string;
        _id: string;
        email: string;
        phone: string;
        blocked: boolean;
      }[];
    }>(
      "/super/employees",
      {},
      {
        headers: {
          authorization: `Bearer ${superAdminKey}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => response.data);

// ? Fetch Single Employee Activity Action
export const fetchActivityOfEmployee =
  (superAdminKey: string) => (empId: string) =>
    axiosInstance
      .post<{
        success: boolean;
        activity: {
          mode: string;
          _id: string;
          createdAt: string;
        }[];
      }>(
        `/super/activity/employee/${empId}`,
        {},
        {
          headers: {
            authorization: `Bearer ${superAdminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// ? Fetch Single Admin Activity Action
export const fetchActivityOfAdmin =
  (superAdminKey: string) => (adminId: string) =>
    axiosInstance
      .post<{
        success: boolean;
        activity: {
          mode: string;
          _id: string;
          createdAt: string;
        }[];
      }>(
        `/super/activity/admin/${adminId}`,
        {},
        {
          headers: {
            authorization: `Bearer ${superAdminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

//  ****** GET ALL ACTIVITY OF EMPLOYEES ******
export const fetchAllActivityOfAdmins =
  (key: string) => (data: { startdate: Date; enddate: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        activity: {
          mode: string;
          createdAt: string;
          admin: {
            _id: string;
            name: string;
          };
        }[];
      }>(`/super/activity/all-admin`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ALL ACTIVITY OF EMPLOYEES ******
export const fetchAllActivityOfEmployees =
  (key: string) => (data: { startdate: Date; enddate: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        activity: {
          mode: string;
          createdAt: string;
          employee: {
            _id: string;
            name: string;
          };
          browser: string;
          device: string;
          ip: string;
          os: string;
          screenSize: string;
        }[];
      }>(`/super/activity/all-employee`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET EMPLOYEE CHECKINS ******
export const getEmployeeCheckinsAsSA =
  (superAdminKey: string) => (empId: string) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        checkins?: {
          mode: string;
          createdAtIST: string | Date;
          createdAt: string | Date;
          _id: string;
          employee: {
            name: string;
            email: string;
          };
          workDoneToday: string;
          attachments?: {
            doc: string;
            url: string;
          }[];
        }[];
      }>(
        `/super/checkins/${empId}`,
        {},
        {
          headers: {
            authorization: `Bearer ${superAdminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

//  ****** GET ALL ACTIVITY OF AN EMPLOYEE BY DATE ******
export const fetchAllActivityOfEmployeeByDate =
  (key: string) =>
  (data: { startdate: Date; enddate: Date; employee: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        activity: {
          mode: string;
          createdAt: string;
          employee: {
            _id: string;
            name: string;
          };
        }[];
      }>(`/super/activity/date-employee`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ALL ACTIVITY OF AN ADMIN BY DATE ******
export const fetchAllActivityOfAdminByDate =
  (key: string) => (data: { startdate: Date; enddate: Date; admin: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        activity: {
          mode: string;
          createdAt: string;
          admin: {
            _id: string;
            name: string;
          };
        }[];
      }>(`/super/activity/date-admin`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ALL ACTIVITY OF AN ADMIN BY DATE ******
export const fetchAllAssignedLeadLogsByDate =
  (key: string) => (data: { startdate: Date; enddate: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        logs: {
          alloted: boolean;
          createdBy: {
            _id: string;
            name: string;
          };
        }[];
      }>(`/lead/super/assigned/all-logs`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ALL ACTIVITY OF AN ADMIN BY DATE ******
export const fetchAllClosedLeadLogsByDate =
  (key: string) => (data: { startdate: Date; enddate: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        logs: {
          alloted: boolean;
          createdBy: {
            _id: string;
            name: string;
          };
        }[];
      }>(`/lead/super/closed/logs`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ALL ATTENDANCE OF AN EMPLOYEE BY DATE ******
export const fetchAllAttendanceOfEmployeeByDate =
  (key: string) =>
  (data: { startdate: Date; enddate: Date; employee: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        attendance: {
          date: string;
          hoursWorked: number;
          status: string;
          _id: string;
        }[];
      }>(`/attendance/month/one-employee`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ALL LEADS ******
export const fetchAllLeaveApplicationsForSA =
  (key: string) => (data: { startdate: Date; enddate: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        LeaveApplication?: {
          _id: string;
          leaveType: string;
          reason: string;
          startDate: string | Date;
          endDate: string | Date;
          status: string;
          employee: {
            name: string;
            email: string;
          };
          createdAt: Date | string;
          attachment: string;
          isPaid: boolean;
        }[];
      }>(`/leave/super/fetch`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET EMPLOYEE CHECKINS BY DATE ******
export const getEmployeeCheckinsByDate =
  (superAdminKey: string) =>
  (data: { employeeId: string; date: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        employee?: {
          _id: string;
          name: string;
          email: string;
        };
        date?: string;
        checkins?: {
          _id: string;
          mode: string;
          createdAt: string | Date;
          isLate: boolean;
          notes?: string;
          workDoneToday?: string;
          ip?: string;
          device?: string;
          browser?: string;
          officeNetwork?: boolean;
          serverIp?: string;
        }[];
      }>(
        `/super/checkins/employee/${data.employeeId}/by-date`,
        { date: data.date },
        {
          headers: {
            authorization: `Bearer ${superAdminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

//  ****** GET EMPLOYEES BY ADMIN ******
export const getEmployeesByAdmin =
  (superAdminKey: string) => (adminId: string) =>
    axiosInstance
      .get<{
        success: boolean;
        employees: {
          name: string;
          _id: string;
          email: string;
          phone: string;
          blocked: boolean;
        }[];
      }>(`/super/admin/${adminId}/employees`, {
        headers: {
          authorization: `Bearer ${superAdminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);
